import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import { AuthProvider } from './AuthContext';
import { UserProvider } from './contexts/UserContext';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(

  <React.StrictMode>

    <AuthProvider>

      <UserProvider>

        <App />

      </UserProvider>

    </AuthProvider>

  </React.StrictMode>
);